import styled from 'styled-components/macro';
export const InputWithIconContainerStyled = styled.div `
  position: relative;
`;
export const IconContainerStyled = styled.div `
  position: absolute;
  top: 38px;

  ${({ isRightToLeft }) => (isRightToLeft ? 'left: 10px;' : 'right: 10px;')}
`;
